import {Component, OnInit} from '@angular/core';
import {UserPermissionsModel} from '@shared/models/user-permission.model';
import {TranslateContext} from '@shared/pipes/translate.pipe';
import {ActivatedRoute, Router} from '@angular/router';
import {PermissionService} from '@shared/service/permission.service';
import {AdministrationPanelItemStyles} from '@shared/components/administration-pannel/administration-panel-item/administration-panel-item.component';
import {AdministrationUserPermissions} from '../../../permissions-variables';
import {ROOT_ADMINISTRATION_CHANNELING, ROOT_ADMINISTRATION_RULES, ROOT_ADMINISTRATION_USER_MANAGEMENT} from '../../../app-routing-roots';
import {ADMINISTRATION_RULES} from '../../../administration/administration-rules/administration-rules-routing-roots';
import {ADMINISTRATION_DASHBOARD} from '../../../administration/administration-channeling/administration-channeling-routing-roots';
import {ADMINISTRATION_USER} from '../../../administration/administration-user-management/administration-users-routing-roots';
import {LoaderService} from '@shared/service/loader.service';

interface DashboardItem {
	label: string;
	description: string;
	link: Link[];
}

interface Link {
	section: number;
	row: number;
	class: string;
	path: string;
	name: string;
}

@Component(
	{
		selector: 'amd-administration-panel',
		templateUrl: './administration-panel.component.html',
		styleUrls: ['./administration-panel.component.scss']
	}
)

export class AdministrationPanelComponent implements OnInit {

	administrationDashboardItemsStyle: typeof AdministrationPanelItemStyles = AdministrationPanelItemStyles;
	_jsonDashboardConfigFile: {
		user_dashboard: DashboardItem[],
		user_administration: {
			permission: string,
			path: string,
			name: string,
			description: string
		}[]
	} = require('./administration-panel.config.json');
	sectionedRowedDashboardItems: Link[][][] = [];
	currentUserPermissions: UserPermissionsModel;
	translateContext: TranslateContext = TranslateContext.ADMINISTRATION;
	selectedModuleTab: number = 0;
	selectedProfileTab: number = 0;
	subModules: Link[] = [];
	maxSection: number = 2;
	userList: {
		permission: string,
		path: string,
		name: string,
		description: string
	}[] = [];
	dashboardItems: DashboardItem[] = [];

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		public permissionService: PermissionService,
		private loaderService: LoaderService
	) {
	}


	ngOnInit(): void {
		this.loaderService.display(true);

		let redirect_url: string;
		switch (true) {
			case (
				this.permissionService.getCurrentUserPermissions().hasPermissions(AdministrationUserPermissions.administration_channeling_can_create_group) &&
				!this.permissionService.getCurrentUserPermissions().hasPermissions(AdministrationUserPermissions.administration_rules_can_create_set) &&
				!this.permissionService.getCurrentUserPermissions().hasPermissions(AdministrationUserPermissions.administration_user_management_modify_user)
			):
				redirect_url = `${ROOT_ADMINISTRATION_CHANNELING}/${ADMINISTRATION_DASHBOARD}`;
				break;
			case (
				!this.permissionService.getCurrentUserPermissions().hasPermissions(AdministrationUserPermissions.administration_channeling_can_create_group) &&
				this.permissionService.getCurrentUserPermissions().hasPermissions(AdministrationUserPermissions.administration_rules_can_create_set) &&
				!this.permissionService.getCurrentUserPermissions().hasPermissions(AdministrationUserPermissions.administration_user_management_modify_user)
			):
				redirect_url = `${ROOT_ADMINISTRATION_RULES}/${ADMINISTRATION_RULES}`;
				break;
			case (
				!this.permissionService.getCurrentUserPermissions().hasPermissions(AdministrationUserPermissions.administration_channeling_can_create_group) &&
				!this.permissionService.getCurrentUserPermissions().hasPermissions(AdministrationUserPermissions.administration_rules_can_create_set) &&
				this.permissionService.getCurrentUserPermissions().hasPermissions(AdministrationUserPermissions.administration_user_management_modify_user)
			):
				redirect_url = `${ROOT_ADMINISTRATION_USER_MANAGEMENT}/${ADMINISTRATION_USER}`;
				break;
		}

		if (!!redirect_url) {
			this.router.navigate([redirect_url]).then();
		} else {

			this.route.data.subscribe(
				() => {
					this.currentUserPermissions = this.permissionService.getCurrentUserPermissions();
					this.setDashboardItems();
				}
			);

			this.loaderService.display(false);
		}
	}

	private setDashboardItems(): void {
		this.dashboardItems = [];

		this._jsonDashboardConfigFile.user_dashboard.forEach(
			element => {
				if (!!this.currentUserPermissions.getProfileFromModule(element.label)) {
					this.dashboardItems.push(
						{
							label: element.label,
							description: element.description,
							link: element.link.map(
								link => (
									{
										class: link.class,
										path: link.path,
										name: link.name,
										row: link.row,
										section: link.section
									}
								)
							)
						}
					);
				}
			}
		);

		this._jsonDashboardConfigFile.user_administration.forEach(element => this.userList.push(element));
	}


	moduleSelectedValue(module: any): void {
		this.selectedProfileTab = 0;

		this.dashboardItems.forEach(
			element => {
				if (module.tab.textLabel === element.description) {
					this.subModules = element.link;
					element.link.forEach(
						liTemp => {
							if (this.maxSection < liTemp.section) {
								this.maxSection = liTemp.section;
							}
						}
					);
				}
			}
		);

		const rowedDashboardItems: Link[][] = [];

		this.dashboardItems.forEach(
			item => {
				if (module.tab.textLabel === item.description) {
					item.link.forEach(element => {
							rowedDashboardItems[element.row] ? rowedDashboardItems[element.row].push(element) : rowedDashboardItems[element.row] = [element];
						}
					);
				}
			}
		);

		this.sectionedRowedDashboardItems = [];

		rowedDashboardItems.filter(r => r.length).forEach(
			row => {
				const sectionIndex: number = row[0].section;
				this.sectionedRowedDashboardItems[sectionIndex] ? this.sectionedRowedDashboardItems[sectionIndex].push(row) : this.sectionedRowedDashboardItems[sectionIndex] = [row];
			}
		);

		this.sectionedRowedDashboardItems = this.sectionedRowedDashboardItems.filter(s => s.length);
	}

	onDashboardItemClick(action: string): void {
		this.router.navigate([[action].join('/')]).then();
	}
}
